import styled from 'styled-components';

const Wrap = styled.div`
  /* background: #d7f1ff; */
  background: linear-gradient(
    345.77deg,
    rgba(33, 170, 232, 0) -15.42%,
    rgba(33, 170, 232, 0.5) 129.02% 182.39deg,
    #bfecff -11.44%,
    #eefdff 35.43%,
    #ffffff 96.07%
  );
`;
const Content = styled.div`
  padding: 32px;
  margin: 32px 0px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #a5f3fd;
  border-radius: 8px;
`;
const ErrorInline = styled.div`
  font-size: 12px;
  padding: 5px 0 0;
  color: #ad0000;
`;
export default { Wrap, Content, ErrorInline };
